import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Download PDF")

import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

import { getDomainPath } from '@/services';
import { useGetDeviceGroupQuery } from '@/entities/device-group/hooks';

import {
  NkEntry,
  NkContainer,
  NkStack,
  NkGroup,
  NkBox,
  NkHeading,
  NkInlineModal,
  NkButton,
} from '@/core/components';

import DeviceGroupEntry from '@/entities/device-group/components/DeviceGroupEntry.vue';
import DeviceEntry from '@/entities/device/components/DeviceEntry.vue';

import NkInspectionGroupTable
  from '@/entities/inspection-group/components/InspectionGroupTable.vue';
import NkInspectionKeyFigure from '@/entities/inspection/components/InspectionKeyFigures.vue';

import NkDeviceGroupDelete from '@/entities/device-group/components/form/DeviceGroupDelete.vue';
import NkDeviceGroupEdit from '@/entities/device-group/components/form/DeviceGroupEdit.vue';
import NkDeviceGroupZipUploadForm
  from '@/entities/device-group/components/form/NkDeviceGroupZipUploadForm.vue';
import InspectionBatchPDFDownload
  from '@/entities/inspection/components/InspectionBatchPDFDownload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkDeviceGroup',
  setup(__props) {

const route = useRoute();

const deviceGroupQueryData = computed(() => ({ id: Number(route.params.deviceGroup) }));
const hasDeviceGroupQueryData = computed(() => !!deviceGroupQueryData.value.id);
const { data: currentDeviceGroup, isLoading } = useGetDeviceGroupQuery(deviceGroupQueryData, {
  refetchOnWindowFocus: false,
  enabled: hasDeviceGroupQueryData,
});

const subDeviceGroupIds = computed(() => currentDeviceGroup.value?.subDeviceGroups || []);
const hasSubDeviceGroups = computed(() => !!subDeviceGroupIds.value.length);

const deviceIds = computed(() => currentDeviceGroup.value?.devices || []);
const hasDeviceIds = computed(() => !!deviceIds.value.length);

const DownloadPDFModal = ref();
const handleDownloadPDFModalOpen = () => {
  DownloadPDFModal.value?.openDialog();
};

const handleDownloadPDFModalClose = () => {
  DownloadPDFModal.value?.closeDialog();
};


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NkContainer), { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_unref(NkStack), { spacing: 8 }, {
          default: _withCtx(() => [
            (_unref(currentDeviceGroup))
              ? (_openBlock(), _createBlock(_unref(NkBox), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NkStack), { spacing: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NkGroup), { position: "apart" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NkHeading), { type: "underlined" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(currentDeviceGroup).name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NkGroup), { spacing: 2 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NkInlineModal), {
                                  title: _ctx.$t('device_group.form.title.edit'),
                                  class: "max-w-screen-md"
                                }, {
                                  content: _withCtx(({close}) => [
                                    _createVNode(NkDeviceGroupEdit, {
                                      "device-group": _unref(deviceGroupQueryData).id,
                                      onSubmitted: close
                                    }, null, 8, ["device-group", "onSubmitted"])
                                  ]),
                                  default: _withCtx(() => [
                                    (_ctx.$store.getters['connection/isGranted'](['device_group_edit']))
                                      ? (_openBlock(), _createBlock(_unref(NkButton), {
                                          key: 0,
                                          icon: "NkPencil"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('device_group.action.edit')), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["title"]),
                                _createVNode(_unref(NkInlineModal), {
                                  title: _ctx.$t('device_group.action.delete'),
                                  class: "max-w-screen-md"
                                }, {
                                  content: _withCtx(({close}) => [
                                    _createVNode(NkDeviceGroupDelete, {
                                      id: _unref(deviceGroupQueryData).id,
                                      onSubmitted: close
                                    }, null, 8, ["id", "onSubmitted"])
                                  ]),
                                  default: _withCtx(() => [
                                    (_ctx.$store.getters['connection/isGranted'](['device_group_delete']))
                                      ? (_openBlock(), _createBlock(_unref(NkButton), {
                                          key: 0,
                                          icon: "NkDelete",
                                          type: "danger"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('device_group.action.delete')), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["title"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(hasDeviceIds) || _unref(hasSubDeviceGroups) )
              ? _withDirectives((_openBlock(), _createBlock(DeviceGroupEntry, {
                  key: 1,
                  parent: _unref(deviceGroupQueryData).id
                }, null, 8, ["parent"])), [
                  [_directive_loading, _unref(isLoading)]
                ])
              : _createCommentVNode("", true),
            (!_unref(hasSubDeviceGroups))
              ? (_openBlock(), _createBlock(DeviceEntry, {
                  key: 2,
                  type: 8,
                  "device-group": _unref(deviceGroupQueryData).id
                }, null, 8, ["device-group"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(NkEntry), {
              title: _ctx.$t('misc.key_figures')
            }, {
              default: _withCtx(() => [
                _createVNode(NkInspectionKeyFigure)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_unref(NkEntry), {
              title: _ctx.$t('misc.inspections')
            }, {
              actions: _withCtx(() => [
                _createVNode(_unref(NkButton), { onClick: handleDownloadPDFModalOpen }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(NkInspectionGroupTable, {
                  type: "device-group",
                  "entity-data": _unref(deviceGroupQueryData),
                  "show-root-farm": false
                }, null, 8, ["entity-data"])
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(NkInlineModal), {
      ref_key: "DownloadPDFModal",
      ref: DownloadPDFModal,
      title: "Download PDF",
      class: "max-w-4xl",
      onClose: handleDownloadPDFModalClose
    }, {
      content: _withCtx(() => [
        _createVNode(InspectionBatchPDFDownload, {
          "device-group-id": _unref(deviceGroupQueryData).id,
          onClose: handleDownloadPDFModalClose
        }, null, 8, ["device-group-id"])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})